/*
data
  storeKey
computeds
  add
  edit
  defaultItem
*/
import { assignAccess } from '@/functions/general.js';
import {
  save,
  addItem,
  askForDelete,
  deleteItem,
} from '@/components/mixins/simpleCrud/SimpleCrudMethods.js';

export default {
  data() {
    return {
      deleteDialog: false,
      dialog: false,
      selectedItem: {},
    };
  },
  computed: {
    rows() { return this.$store.getters[this.storeKey] },
  },
  methods: {
    assignAccess,
    save,
    addItem,
    askForDelete,
  	deleteItem,
  },
};